export const styleSidebar = `relative duration-300 bg-white
	shadow-lg flex flex-col justify-between p-5`;

export const styleToggler = `absolute cursor-pointer
		w-6 border-2 hover:border-gray-400
		duration-200 border-gray-200
		rounded-full -right-3 top-9`;
export const styleArrow = `cursor-pointer
		w-6 border-2 hover:border-gray-400
		duration-200 border-gray-200
		rounded-full`;

export const H1 = `font-bold text-2xl text-dark-main mb-3`;

export const INPUT = `px-5 p-2 bg-gray-100 rounded-xl outline-none`;

export const COL = `flex flex-col flex-1 gap-3`;

export const BUTTON = `
				bg-green-main 
				text-dark-main 
				text-center 
				font-semibold 
				px-10 py-3 rounded-2xl mt-1
				hover:bg-green-dark duration-200
				`;

export const LABEL = `font-medium text-lg ml-1`;
